import React from "react";
import renderUtils from "./renderUtils";
import { useTranslation } from 'react-i18next';

export function RenderEditionDetails({ description, title }) {
    const { t } = useTranslation();
    
    // Parse the JSON string
    let detailsArray;
    try {
        detailsArray = JSON.parse(description);
    } catch (e) {
        console.error(t("audit.error_preparing_details"), e);
        return <li>Invalid description format</li>;
    }

    if (!Array.isArray(detailsArray)) {
        return <li>Description is not array</li>;
    }
    // Map field names to their display labels
    const fieldLabels = {
        internalNumber: t("common.internal_number"),
        packingSystem: t("common.packing_system"),
        files: t("common.photos"),
        images: t("common.photos"),
        contactWithProduct: t("common.contact_with_product"),
        installationNumber: t("common.installation_number"),
        partNumber: t("common.part_number"),
        position: t("common.position"),
        comment: t("common.comment"),
        value: t("common.value"),
        "operatingParameterTemplates count": t("common.parameters_count"),
        name: t("common.name"),
        room: t("common.room"),
        model: t("common.model"),
        active: t("common.active"),
        ignore: t("common.ignore"),
        // Add more fields here as needed
    };

    const formatValue = (fieldName, value) => {
        if (value === null || value === "null" || value.trim() === "") {
            return t("common.no_value");
        }
        if (fieldName === "packingSystem") {
            return renderUtils.renderEnumName(value, "enums/packingSystem", t);
        }
        if (fieldName === "typeOfSeries") {
            return renderUtils.renderEnumName(value, "enums/typeOfSEries", t);
        }
        if (fieldName === "contactWithProduct") {
            return value === "true" ? t("common.yes") : value === "false" ? t("common.no") : t("common.no_value");
        }
        if (fieldName === "active") {
            return value === "true" ? t("common.yes") : value === "false" ? t("common.no") : t("common.no_value");
        }
        if (fieldName === "ignore") {
            return value === "true" ? t("common.yes") : value === "false" ? t("common.no") : t("common.no_value");
        }
        return value;
    };

    // Format each detail as a list item with the field name in bold
    const formattedDetails = detailsArray.map((detail, index) => {
        const fieldName = fieldLabels[detail.fieldName] || detail.fieldName;

        const oldValue = formatValue(detail.fieldName, detail.oldValue);
        const newValue = formatValue(detail.fieldName, detail.newValue);

        return (

            <li key={index}>
                <strong>{fieldName}</strong>: {oldValue} {'->'} {newValue}
            </li>

        );
    });

    // Return all list items wrapped in a single <ul> element
    return <div>
        {title &&
            <p>{title}</p>
        }
        <ul>{formattedDetails}</ul>
    </div>
        ;
}

// Legacy function for backward compatibility - will need to be updated where used
export function renderEditionDetails(description, title) {
    // This function should be replaced with the RenderEditionDetails component
    // For now, return basic structure without translations
    let detailsArray;
    try {
        detailsArray = JSON.parse(description);
    } catch (e) {
        console.error("Błąd przy przygotowaniu szczegółów: ", e);
        return <li>Invalid description format</li>;
    }

    if (!Array.isArray(detailsArray)) {
        return <li>Description is not array</li>;
    }

    const formattedDetails = detailsArray.map((detail, index) => {
        return (
            <li key={index}>
                <strong>{detail.fieldName}</strong>: {detail.oldValue} {'->'} {detail.newValue}
            </li>
        );
    });

    return <div>
        {title && <p>{title}</p>}
        <ul>{formattedDetails}</ul>
    </div>;
}